import {
    useLayoutEffect,
    type DependencyList,
    type EffectCallback,
} from "react";

export function useUnsafeLayoutEffect(
    effect: EffectCallback,
    dependencies?: DependencyList,
): void {
    // oxlint-disable-next-line react-hooks/exhaustive-deps -- the caller owns the dependency list
    useLayoutEffect(effect, dependencies);
}
